import{theme as e}from"./theme.js";const t=Object.keys(e.breakpoints).reduce(((t,r)=>{const o=e.breakpoints[r];return t[r]=`${o}em`,t}),{});export{t as breakpoints};
//# sourceMappingURL=breakpoints.js.map
